import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType } from './chatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwo = {
  content?: string;
  type?: ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType;
};
